import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SmtpAccountView } from '@bom/shared';
import { api } from '../lib/apiClient';

/** 我的发件邮箱簿（跨产品复用，只属本人；不回显密码） */
export function useMySmtpAccounts() {
  return useQuery({
    queryKey: ['smtp-accounts'],
    queryFn: () =>
      api.get<{ accounts: SmtpAccountView[] }>('/me/smtp-accounts').then((r) => r.accounts),
  });
}

export function useDeleteSmtpAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (accountId: string) => api.del<void>(`/me/smtp-accounts/${accountId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['smtp-accounts'] }),
  });
}

/** 把已保存邮箱应用到当前产品（服务端复制配置含密码密文） */
export function useApplySmtpAccount(tid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (accountId: string) =>
      api.post<void>(`/tenants/${tid}/email-config/from-account`, { account_id: accountId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['email-config', tid] }),
  });
}
